import React from "react";
import { Button, Drawer, Input, InputNumber, Space, Table, Tag, Typography } from "antd";
import { RobotOutlined } from "@ant-design/icons";

const { Text } = Typography;
const { TextArea } = Input;

const BulkAIPostsDrawer = ({
  open,
  onClose,
  topic,
  setTopic,
  count,
  setCount,
  topics,
  selectedIDs,
  setSelectedIDs,
  generatingTopics,
  creatingPosts,
  onGenerateTopics,
  onCreatePosts,
  isMobile = false,
}) => {
  const columns = [
    {
      title: "Tiêu đề gợi ý",
      dataIndex: "title",
      width: isMobile ? 260 : 340,
      render: (value) => <Text strong>{value || "-"}</Text>,
    },
    {
      title: "Tóm tắt",
      dataIndex: "excerpt",
      ellipsis: true,
      render: (value) => <Text type="secondary">{value || "-"}</Text>,
    },
    {
      title: "Danh mục",
      dataIndex: "category_names",
      width: isMobile ? 220 : 260,
      render: (values) => {
        const rows = Array.isArray(values) ? values : [];
        if (rows.length === 0) {
          return <Text type="secondary">-</Text>;
        }
        return rows.slice(0, 3).map((item) => <Tag key={`${item}`}>{item}</Tag>);
      },
    },
    {
      title: "Từ khóa",
      dataIndex: ["seo", "meta_keywords"],
      width: isMobile ? 220 : 260,
      render: (values) => {
        const rows = Array.isArray(values) ? values : [];
        if (rows.length === 0) {
          return <Text type="secondary">-</Text>;
        }
        return rows.slice(0, 3).map((item) => <Tag color="blue" key={`${item}`}>{item}</Tag>);
      },
    },
  ];

  return (
    <Drawer
      width={isMobile ? "100%" : 1080}
      title="Tạo bài viết hàng loạt bằng AI"
      open={open}
      onClose={onClose}
      extra={
        isMobile ? null : (
          <Space>
            <Button onClick={onClose} disabled={generatingTopics || creatingPosts}>Đóng</Button>
            <Button
              type="primary"
              icon={<RobotOutlined />}
              loading={creatingPosts}
              onClick={onCreatePosts}
              disabled={topics.length === 0}
            >
              Tạo bài đã chọn
            </Button>
          </Space>
        )
      }
      footer={
        isMobile ? (
          <Space style={{ width: "100%" }}>
            <Button block onClick={onClose} disabled={generatingTopics || creatingPosts}>Đóng</Button>
            <Button
              block
              type="primary"
              icon={<RobotOutlined />}
              loading={creatingPosts}
              onClick={onCreatePosts}
              disabled={topics.length === 0}
            >
              Tạo bài đã chọn
            </Button>
          </Space>
        ) : null
      }
    >
      <Space direction="vertical" size={14} style={{ width: "100%" }}>
        <Space direction="vertical" size={10} style={{ width: "100%" }}>
          <TextArea
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            placeholder="Nhập chủ đề, ví dụ: tối ưu vận hành bán sỉ"
            rows={isMobile ? 4 : 3}
            maxLength={500}
            showCount
            style={{ width: "100%" }}
          />
          <Space direction={isMobile ? "vertical" : "horizontal"} size={10} style={{ width: "100%" }}>
            <InputNumber
              min={1}
              max={30}
              value={count}
              onChange={(value) => setCount(Math.max(1, Math.min(30, Number(value) || 5)))}
              style={{ width: isMobile ? "100%" : 160 }}
              addonBefore="Số bài"
            />
            <Button
              type="primary"
              icon={<RobotOutlined />}
              loading={generatingTopics}
              onClick={onGenerateTopics}
              block={isMobile}
            >
              Tạo danh sách
            </Button>
          </Space>
        </Space>

        <Space style={{ width: "100%", justifyContent: "space-between" }}>
          <Text strong>Danh sách chủ đề AI</Text>
          <Text type="secondary">Đã chọn: {selectedIDs.length}</Text>
        </Space>

        <Table
          rowKey="id"
          size="small"
          columns={columns}
          dataSource={topics}
          rowSelection={{
            selectedRowKeys: selectedIDs,
            onChange: (keys) => setSelectedIDs(keys),
          }}
          pagination={false}
          locale={{ emptyText: "Chưa có chủ đề. Hãy nhập chủ đề và bấm Tạo danh sách." }}
          scroll={isMobile ? { x: 900 } : undefined}
        />
      </Space>
    </Drawer>
  );
};

export default BulkAIPostsDrawer;
